import { Text, View } from 'react-native'
import { styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
    },
  }
})

export const StepsContainer = styled(View, theme => {
  return {
    base: {
      flexGrow: 1,
      justifyContent: 'center',
    },
  }
})

export const StepsText = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
    },
  }
})

export const ButtonsContainer = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      gap: theme.sizingMicro,
    },
  }
})
